import React from 'react';

import { MapMenu } from '../map/map-menu';
import { PlayerState } from '../../../types/state';
import { GameContext } from '../../../contexts/game';
import { Menu } from '../../../types/facilitator/map-menu';
import { roundingDecimalNumber } from '../../../utils/number';
import { GetZoneTitle } from '../../../utils/game-document/assets';
import { GameDocumentContext } from '../../../contexts/game-document';
import { getPlayerLocationColorStatus } from '../../../utils/game-document/location';

export const PlayersMenu: React.FC<{
  search: string;
  selectedMenu: Menu | undefined;
  setSelectedMenu: (value: React.SetStateAction<Menu | undefined>) => void;
}> = ({ search, selectedMenu, setSelectedMenu }) => {
  const [gameDocument] = React.useContext(GameDocumentContext);

  const [gameState] = React.useContext(GameContext);

  const getPlayerLocation = (playerState: PlayerState) => {
    if (playerState.location === '' || !playerState?.location) {
      return '--';
    } else if (playerState.location === 'world-map') {
      return 'world-map';
    } else {
      return (
        GetZoneTitle(gameDocument?.gameDocument, playerState.location) || '--'
      );
    }
  };

  const players: Menu[] = React.useMemo(
    () =>
      gameState?.gameState?.players
        ?.map((player) => ({
          name: player.name ?? '',
          code: player.code ?? '',
          type: 'player' as 'player',
          score: roundingDecimalNumber(player?.score ?? 0, 2) ?? '',
          statusColor: getPlayerLocationColorStatus(player.lastUpdated),
          location: getPlayerLocation(player),
          locationId: player.location
        }))
        ?.sort((a, b) => b.score - a.score) || [],
    [gameState.gameState?.players]
  );

  return (
    <div className="list-group w-100 bg-transparent d-flex">
      {players
        ?.filter((x) => x.name?.toLowerCase()?.includes(search?.toLowerCase()))
        ?.map((menu) => (
          <MapMenu
            key={menu.code}
            menu={menu}
            selectedMenu={selectedMenu}
            onChange={(v) => setSelectedMenu(v)}
          />
        ))}
    </div>
  );
};
